import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
	loadDistrictData,
	loadDistrictDataBuyId,
} from "../../../store/district";
import PropTypes from "prop-types";
import {Header, Main, Sidebar} from "../../poi/partials";
import {Wrapper} from "../../index";
import styles from "./styles";
import {withStyles} from "@material-ui/core";
import SlideShow from "./SlideShow";
import Details from "./Details";
import classNames from "classnames";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

const Poi = ({classes, match}) => {
	const bottomRef = useRef();
	const topRef = useRef();
	const contentRef = useRef();
	const {poi} = match.params;
	const dispatch = useDispatch();
	const {data, poiItem} = useSelector(state => state.district);
	const [displayDownButton, setDisplayDownButton] = useState(true);
	const [displayUpButton, setDisplayUpButton] = useState(false);

	useEffect(() => {
		dispatch(loadDistrictData());
	}, []);

	useEffect(() => {
		if (data.length) {
			dispatch(loadDistrictDataBuyId(poi));
			window.addEventListener("scroll", handleScroll);
		}
	}, [data]);

	const handleScroll = () => {
		if (window.pageYOffset > window.innerHeight-60) {
			setDisplayDownButton(false);
			setDisplayUpButton(true);
		}else{
			setDisplayDownButton(true);
			setDisplayUpButton(false);
		}
	};
	const handleScrollToBottom = () => {
		bottomRef.current.scrollIntoView({
			behavior: "smooth",
			block: "start",
		});
	};
	const handleScrollToTop = () => {
		topRef.current.scrollIntoView({
			behavior: "smooth",
			block: "start",
		});
	};

	return (
		<div ref={contentRef}>
			<div ref={topRef} className="list-bottom"/>
			<Header className={classes.header}/>
			<div className={classes.wrapperPoi}>
				{poiItem && poiItem.images.length && (
					<>
						<SlideShow
							className={classes.main}
							classes={classes}
							poiItem={poiItem}
						/>
						<Details
							className={classes.sidebar}
							poi={poiItem}
							classes={classes}
						/>
					</>
				)}
			</div>
			<div ref={bottomRef} className="list-bottom"/>
			<div className={classNames(classes.scrollDown)}>
				{displayDownButton && (
					<ExpandMoreIcon
						className={classes.colorWhite}
						onClick={handleScrollToBottom}
					/>
				)}
				{displayUpButton && (
					<ExpandLessIcon
						className={classes.colorWhite}
						onClick={handleScrollToTop}
					/>
				)}
			</div>
		</div>
	);
};
Poi.propTypes = {
	classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(Poi);
